import React from "react";
import styled from "styled-components";
import { ImageProps, TokenPairImageProps, Variant, variants } from "./types";
import Wrapper from "./Wrapper";

import TokenImage from "./TokenImage";


interface StyledImageProps extends ImageProps {
  variant: Variant;
}


const TokenPairImageV2: React.FC<TokenPairImageProps> = ({
  secondarySrc,
  thirdSrc,
  width,
  height,
  variant = variants.DEFAULT,
  secondaryImageProps = {},
  thirdImageProps = {},
  ...props
}) => {
  const secondaryImageSize = Math.floor(width / 2);

  return (
    <Wrapper position="relative" width={width} height={height} {...props}>
    <StyledPrimaryImage 
        variant={variant}
        src={secondarySrc}
        width={secondaryImageSize}
        height={secondaryImageSize}
        {...secondaryImageProps}
    />
      <StyledThirdImage variant={variant} src={thirdSrc} width={32} height={32} {...thirdImageProps} />
    </Wrapper>
  );
};

export default TokenPairImageV2;

const StyledPrimaryImage = styled(TokenImage)<StyledImageProps>`
  position: absolute;
  border-radius:50%;
  height: 46px;
  width: 46px;
  left: 20px;
  @media screen and (max-width: 600px) {
    left: 10px;
  }
  &:before{
    border:none !important;
  }
`;

export const StyledThirdImage = styled(TokenImage)<StyledImageProps>`
  border-radius:50%;
  left:55px;
  top: 30px;
  @media screen and (max-width: 600px) {
    left:45px;
  }
  height: 28px;
  width: 28px;
  border:none !important;
`;
